import React from 'react';
import ITPDiagram from "./ITPDiagram";

const CoverPage = ({ type = 'ASSESSMENT', assessment = null }) => {
	return (
		<div className='Cover'>
			<div className='top py-8 mx-auto'>
				<div className={'w-2/3 mx-auto'}>
					<p className={'top-title'}>{type} REPORT</p>
				</div>
			</div>

			<div className='mt-[7.5rem]'>
				<h1 className={'cover-page-title'}>T<span>HE</span> I<span>DEAL</span></h1>
				<h1 className={'cover-page-title pt-6'}>T<span>EAM</span> P<span>LAYER</span></h1>
			</div>

			<div className='mt-12 w-16 mx-auto'>
				<hr className="mx-auto border-[#455969]"/>
			</div>

			<div className='mx-auto'>
				<p className='tagline'>
					{assessment?.name}
				</p>
			</div>

			<div className="w-[55%] mx-auto flex justify-center items-center">
				<ITPDiagram
					strokeColor="#1F2937"
					strokeWidth={'1px'}
					humbleTextColor={'#fff'}
					hungryTextColor={'#fff'}
					smartTextColor={'#fff'}
					fillHumble={'#80929d'}
					fillHungry={'#263e4b'}
					fillSmart={'#1c2130'}
					id={'coverPage'}
					className="max-w-full max-h-full"
					titleTextSize={'23px'}
					subtitleTextSize={'18px'}
					radius={130}
				/>
			</div>

			<div className='powered-by'>
				<p className={'pb-1'}>Powered by:</p>
				<img src='../../images/assessments/report/img/cover/TTGWhiteReportLogo.png' alt={''} />
			</div>
		</div>
	);
};

export default CoverPage;
